import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Star, ChevronRight } from 'lucide-react';

export default function PendingReviewBanner({ pendingReview, onReviewClick }) {
  if (!pendingReview) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: 'short' 
    });
  };

  return (
    <Card 
      className="bg-gradient-to-r from-yellow-50 to-amber-50 border-yellow-200 p-4 cursor-pointer hover:shadow-md transition-shadow"
      onClick={onReviewClick}
      data-testid="pending-review-banner"
    >
      <div className="flex items-center gap-4">
        <div className="bg-yellow-100 p-3 rounded-full">
          <Star className="w-6 h-6 text-yellow-600" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-semibold text-yellow-900">
            Avalie sua lavagem!
          </h3>
          <p className="text-sm text-yellow-700">
            {pendingReview.provider_name} • {formatDate(pendingReview.date)}
          </p>
        </div>

        <Button 
          variant="ghost" 
          size="sm"
          className="text-yellow-700 hover:text-yellow-900 hover:bg-yellow-100"
        >
          Avaliar
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </Card>
  );
}
